import { useState } from 'react';

import { format } from 'date-fns';
import { EditIcon, KeyRoundIcon, MailIcon } from 'lucide-react';
import { useSnapshot } from 'valtio';

import PortalCardWrapper from '../../components/pages/customer-portal/card-wrapper.jsx';
import PortalContainer from '../../components/pages/customer-portal/container.jsx';
import { CustomerAuthenticationWrapper } from '../../components/pages/customer-portal/customer-portal-authentication-wrapper.jsx';
import { DialogCustomerUpdateEmail } from '../../components/pages/customer-portal/dialogs/customer-action-update-email.jsx';
import { DialogAccountUpdatePassword } from '../../components/pages/customer-portal/dialogs/customer-action-update-password.jsx';
import { DialogDeleteAccount } from '../../components/pages/customer-portal/dialogs/customer-delete-account.jsx';
import FormCustomerInfo from '../../components/pages/customer-portal/forms/form-customer-info.jsx';
import PortalHeading from '../../components/pages/customer-portal/heading.jsx';
import DecorativeInput from '../../components/decorative-input.jsx';
import { Button } from '../../components/ui/button.jsx';
import { Checkbox } from '../../components/ui/checkbox.jsx';
import { Separator } from '../../components/ui/separator.jsx';
import { authState } from '../../services/state/auth-state.jsx';

export default function CustomerPortalAccount() {
  const { user } = useSnapshot(authState);
  const [isEditingCustomerInfo, setIsEditingCustomerInfo] = useState(false);

  return (
    <CustomerAuthenticationWrapper>
      <PortalContainer>
        <div className="flex flex-col gap-y-10">
          <PortalCardWrapper>
            <div className="flex flex-col justify-start md:flex-row md:justify-between">
              <PortalHeading>A minha Conta</PortalHeading>
              {!isEditingCustomerInfo ? (
                <Button
                  variant="portal"
                  onClick={() => setIsEditingCustomerInfo(true)}
                >
                  <EditIcon /> Editar Conta
                </Button>
              ) : null}
            </div>

            {isEditingCustomerInfo ? (
              <FormCustomerInfo
                onCancel={() =>
                  setIsEditingCustomerInfo(!isEditingCustomerInfo)
                }
                onSuccess={() =>
                  setIsEditingCustomerInfo(!isEditingCustomerInfo)
                }
              />
            ) : (
              <div className="grid gap-x-10 gap-y-4 lg:grid-cols-2">
                <DecorativeInput
                  variant="portal"
                  value={user?.details?.firstName}
                  label="Nome"
                />
                <DecorativeInput
                  variant="portal"
                  value={user?.details?.lastName}
                  label="Apelido"
                />
                <DecorativeInput
                  variant="portal"
                  value={user?.details?.cc}
                  label="Nº de documento comprovativo de identidade"
                />
                <DecorativeInput
                  variant="portal"
                  value={
                    user?.details?.birthDate
                      ? format(user.details.birthDate, 'dd-MM-yyyy')
                      : ''
                  }
                  label="Data de nascimento"
                />
                <DecorativeInput
                  variant="portal"
                  value={user?.details?.phone}
                  label="Nº Telemóvel"
                />
                <DecorativeInput
                  variant="portal"
                  value={user?.details?.location}
                  label="Localidade"
                />
                <DecorativeInput
                  variant="portal"
                  value={user?.details?.address}
                  label="Morada"
                />
                <DecorativeInput
                  variant="portal"
                  value={user?.details?.district}
                  label="Distrito"
                />
                <DecorativeInput
                  variant="portal"
                  value={user?.details?.zipCode}
                  label="Código Postal"
                />

                <div className="col-span-1 flex flex-row items-center space-x-2 pt-4 lg:col-span-2">
                  <Checkbox
                    className="mr-1 size-5"
                    disabled={true}
                    checked={user?.details?.consentTermsOfParticipation}
                  />
                  <p className="ml-4 space-y-0 text-sm font-medium leading-none">
                    Condições de Participação
                  </p>
                </div>

                <div className="col-span-1 flex flex-row items-center space-x-2 lg:col-span-2">
                  <Checkbox
                    className="mr-1 size-5"
                    disabled={true}
                    checked={user?.details?.consentDataSharing}
                  />
                  <p className="ml-4 space-y-0 text-sm font-medium leading-none">
                    Comunicações de Marketing
                  </p>
                </div>

                <div className="col-span-1 flex flex-row items-center space-x-2 lg:col-span-2">
                  <Checkbox
                    className="mr-1 size-5"
                    disabled={true}
                    checked={user?.details?.consentDataSharingLivliFamily}
                  />
                  <p className="ml-4 space-y-0 text-sm font-medium leading-none">
                    Adesão ao Programa de Vantagens Livli Family
                  </p>
                </div>
              </div>
            )}
          </PortalCardWrapper>

          <PortalCardWrapper>
            <div>
              <PortalHeading>Segurança e Privacidade</PortalHeading>
              <p className="font-noto-ikea">
                Mantenha a sua conta sempre segura
              </p>
            </div>

            <div className="grid grid-cols-1 gap-y-4 md:grid-cols-2 md:gap-y-0">
              <div className="flex flex-row items-center gap-x-2 pb-1 text-xl font-bold">
                <MailIcon className="size-6" /> E-mail
              </div>

              <DialogCustomerUpdateEmail />
            </div>

            <Separator />

            <div className="grid grid-cols-1 gap-y-4 md:grid-cols-2 md:gap-y-0">
              <div className="flex flex-row items-center gap-x-2 text-xl font-bold">
                <KeyRoundIcon className="size-6" /> Palavra-passe
              </div>

              <DialogAccountUpdatePassword />
            </div>
          </PortalCardWrapper>

          <DialogDeleteAccount />
        </div>
      </PortalContainer>
    </CustomerAuthenticationWrapper>
  );
}
